import { Snackbar, Alert } from "@mui/material";
import AlertTitle from "@mui/material/AlertTitle";
import React, { useState, useEffect } from "react";
import "./style.css";
import Typography from "@mui/material/Typography";

const NotificationAlert = (props) => {
  const { onClose, open, message, title, severity } = props;
  
   useEffect(() => {
    if (open) {
      document.body.classList.add('disable-interactions');
    } else {
      document.body.classList.remove('disable-interactions');
    }

    return () => {
      document.body.classList.remove('disable-interactions');
    };
  }, [open]);

  return (
    <>
      <Snackbar
        open={open}
        onClose={(event, reason) => {
          if (reason === "clickaway") {
            return;
          }
          onClose();
        }}
        className="alertBox"
      >
        {open && (
          <Alert
            onClose={onClose}
            severity={severity}
            sx={{ background: "#FDEFF3", color: "#B0133A" }}
            className="notificationAlert"
          >
            <AlertTitle sx={{ fontSize: "16px", fontWeight: 600 }}>
              {title}
            </AlertTitle>
            <Typography
              variant="body2"
              sx={{ fontSize: "14px", fontWeight: 400 }}
            >
              {message}
            </Typography>
          </Alert>
        )}
      </Snackbar>
    </>
  );
};

export default NotificationAlert;
